import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {DirectSaleState, GetDirectSaleResponse} from '../types';

const directSaleMock: GetDirectSaleResponse = {
  id: 'd5cdd016-295e-447c-b087-034cb48a0fd3',
  tenantId: 'f2e781c7-16e7-4140-9649-5424bc4fbf4a',
  branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  directSaleVariantId: '55b17e83-4ea9-46e9-8eac-4de1c416e784',
  authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
  number: 'DS000370',
  state: 'OPEN' as DirectSaleState,
  name: 'Mock name',
  description: 'Mock description',
  neededAt: '2024-12-24',
  createdAt: '2024-08-21T10:30:17.736Z',
  createdBy: '98d07dd3-9946-48ad-8392-fb2d77739e7e',
  variantName: 'c[MERCZ] Recommended price for articles,  price ratio 1.0, commercial labour rates',
  hasPendingReturn: false,
  tooltip: {
    authorizationProfile: 'Mercedes (Praha)',
    directSaleType: 'Commercial',
    isUnitPriceWithVat: 'No',
    priceType: 'Recommended price',
    priceTypeRatio: 1,
    minimalMaterialMargin: '0 %',
    rateType: 'Comercial',
    rateTypeRatio: 1,
    minimalWorkMargin: '0 %',
  },
  totalPrice: {
    withoutVat: {
      amount: 15,
      currency: 'EUR',
    },
    withVat: {
      amount: 18.15,
      currency: 'EUR',
    },
  },
  originObjectType: 'direct-sale',
  itemsCount: 10,
  itemsFullyReturnedCount: 0,
};

const getDirectSaleInterceptor = (server: SetupServerApi) =>
  server.use(http.get(`*/warehouse/v1/direct-sale/*`, () => HttpResponse.json(directSaleMock)));

const patchDirectSaleInterceptor = (server: SetupServerApi) =>
  server.use(http.patch('*/warehouse/v1/direct-sale/*', () => HttpResponse.json()));

export const metadaWarehouseDirectSaleApiMock = {
  directSaleMock,
  getDirectSaleInterceptor,
  patchDirectSaleInterceptor,
};
